import styled from "styled-components";
import { Button } from "../../components";
import { VirtualTable } from "../../components/tables";
import { TableRecordCountDisplayFooter } from "../../components/tables/VirtualTable";
import { FiltersAppliedWarningMessage, PageSubHeader, ThemedIcon } from "../../components/utilities";
import { useFilterContext } from "../../hooks/FilterContext";
import { AdviceRegisterFiltersModal, AdviceRegisterTableHeader, AdviceRegisterTableRow } from "./components";
import useAdviceRegister from "./hooks/useAdviceRegister";

const FilterHeader = styled(PageSubHeader)`
    padding: 0.75rem;
`

const AdviceRegister = () => {

    const {
        clear,
        data,
        error,
        isClearing,
        isRowLoaded,
        loadMore,
        currentSort,
        sortTable,
        totalCount,
        exportCsv
    } = useAdviceRegister();
    const { setShowFilterModal, isFiltersApplied, clearFilter } = useFilterContext();

    return <>
        <AdviceRegisterFiltersModal />
        <FilterHeader>
            <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                    {isFiltersApplied && (
                        <>
                            <ThemedIcon icon="fa-triangle-exclamation" size="2x" variant="warning" />
                            <FiltersAppliedWarningMessage className="ms-2 text-muted">
                                Warning - Filters are currently being applied to your results.
                                <br />
                                <button className="anchor" onClick={clearFilter}>Click here</button> to clear your filters.
                            </FiltersAppliedWarningMessage>
                        </>
                    )}
                </div>
                <Button className="ms-auto" variant="success" onClick={exportCsv}>
                    Export Register
                </Button>
                <Button className="mx-2" variant="primary" onClick={() => setShowFilterModal(true)}>
                    Filter Register
                </Button>
            </div>
        </FilterHeader>
        <section className="h-100 px-4 my-3">
            <VirtualTable
                enableScrollTracking
                row={AdviceRegisterTableRow}
                header={<AdviceRegisterTableHeader currentSort={currentSort} sortTable={sortTable} />}
                footer={(
                    <TableRecordCountDisplayFooter
                        spanLeft={8}
                        spanRight={1}
                        totalCount={totalCount}
                        reload={clear}
                    />
                )}
                isLoading={isClearing}
                error={error}
                isItemLoaded={isRowLoaded}
                loadMoreItems={loadMore}
                itemSize={45}
                itemCount={totalCount}
                itemData={data}
            />
        </section>
    </>
}

export default AdviceRegister;